// RiskHubPage — Risk center, margin, auto-flatten, daily pause, news, rules, market data

import { HubLayout } from './HubLayout';

export function RiskHubPage() {
  return (
    <HubLayout
      title="Risk Center"
      testIdRoot="hub-risk"
      hero={{
        title: 'Stay compliant',
        subtitle: 'Limits, rules, news, market data',
        emoji: '🛡️',
        gradient: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)',
        stats: [
          { label: 'Risk score', value: '87',  sub: '/100', color: '#34C759' },
          { label: 'EOD',        value: '3:42', sub: 'until flatten' },
          { label: 'News',       value: '0',   sub: 'alerts', color: '#34C759' },
        ],
      }}
      quickActions={[
        { to: '/portal/risk-center',  label: 'Dashboard',  icon: '🛡️', testId: 'hub-risk-qa-dashboard' },
        { to: '/portal/margin',       label: 'Margin',     icon: '📊', testId: 'hub-risk-qa-margin' },
        { to: '/portal/trading-rules',label: 'Rules',      icon: '📋', testId: 'hub-risk-qa-rules' },
      ]}
      sections={[
        {
          title: 'Risk Monitoring',
          items: [
            { to: '/portal/risk-center',   icon: '🛡️', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Risk dashboard',    sub: '87/100 · healthy', badge: { text: 'Good', color: 'white', bg: '#34C759' } },
            { to: '/portal/margin',        icon: '📊', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Margin monitor',    sub: '11% of 30% limit' },
            { to: '/portal/auto-flatten',  icon: '⏰', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Auto-flatten',      sub: 'EOD 16:00 CT · 3:42 left' },
            { to: '/portal/daily-pause',   icon: '⏸', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'Daily Pause',       sub: 'Section 13.9' },
          ],
        },
        {
          title: 'Rules & Compliance',
          items: [
            { to: '/portal/trading-rules',  icon: '📋', iconBg: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)', label: 'Trading rules',     sub: 'Section 13 · 20 rules' },
            { to: '/portal/news-blackouts', icon: '📰', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)', label: 'News blackouts',    sub: '2-min rule · next 2h 14m' },
          ],
        },
        {
          title: 'Market Data',
          items: [
            { to: '/portal/market-calendar', icon: '📅', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)', label: 'Economic calendar',  sub: 'High-impact events' },
            { to: '/portal/economic-calendar', icon: '🗓️', iconBg: 'linear-gradient(135deg, #FF9500 0%, #FFD60A 100%)', label: 'Economic events',   sub: 'All upcoming events' },
            { to: '/portal/brokers',         icon: '🔌', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'Brokers & data',     sub: '8 platforms connected' },
            { to: '/portal/platforms',       icon: '🎛️', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'All platforms',     sub: 'Deepchart, Rithmic, etc.' },
            { to: '/portal/platform/deepchart', icon: '⚡', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Platform detail',  sub: 'Single platform' },
            { to: '/portal/news',            icon: '📰', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Market news',         sub: 'Latest headlines' },
          ],
        },
      ]}
      footerNote="All risk metrics monitored in real time. Violations auto-flagged."
    />
  );
}
